import { FC, useState } from 'react'
import { useTable, useRowSelect } from 'react-table'

import './style.scss'
import { Dropdown, Tooltip } from '..'

interface TableProps {
  columns: any[],
  data: any[],
  onFilterChange?(value: string): void
}

const Table:FC<TableProps> = ({ columns, data, onFilterChange })  => {
  const [ filterSw, setFilterSw ] = useState<boolean>(false)
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow
  } = useTable(
    {
      columns,
      data,
    },
    useRowSelect
  )

  const onFilterOption = (value: string) => {
    setFilterSw(false)
    if(onFilterChange) onFilterChange(value)
  }

  return (
    <table {...getTableProps()} className="table">
      <thead>
        {headerGroups && headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column: any) =>
              <>
                <th {...column.getHeaderProps(column.sortable ? column.getSortByToggleProps() : '')} className={column.headerClassName} style={{width: column.width, cursor: column.sortable ? 'pointer' : 'default' }}>
                  <p className="table_cell">
                    {column.render('Header')}
                  </p>
                  {column.isSorted ?
                      column.isSortedDesc ?
                          <i className="table-sortable table-sortable--active" />
                        :
                          <i className="table-sortable" />
                    :
                      column.filter ?
                          <>
                            <i className="table-sortable" onClick={() => setFilterSw(!filterSw)} />
                            <Dropdown show={filterSw} className="table_dropdown">
                              <ul className="dropdown_options">
                                <li onClick={() => onFilterOption('')}>
                                  <span>Todos</span>
                                </li>
                                {column.filter.map((it: any, i: number) => <li key={i} className="text-capitalize" onClick={() => onFilterOption(String(it.id))}>
                                  <span>{it.name}</span>
                                </li>)}
                              </ul>
                            </Dropdown>
                          </>
                        :
                          ''
                  }
                  {column.tooltip &&
                    <Tooltip width="160px">
                      {column.tooltip}
                    </Tooltip>
                  }
                </th>
              </>
            )}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows && rows.map((row, i) => {
          prepareRow(row)

          return (
            <tr {...row.getRowProps()}>
              {row.cells.map((cell: any, j) => {
                const { enableRowSpan } = cell.column

                if(enableRowSpan && i > 0) return ''

                return (
                  <td key={j} {...cell.getCellProps()} rowSpan={enableRowSpan ? '5' : null} valign={enableRowSpan ? 'middle' : null} className={cell.column.headerClassName}>
                    <div className="table_cell">{cell.render('Cell')}</div>
                  </td>
                )
              })}
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

export { Table }